import React from "react";
import PropTypes from "prop-types";
import ImgContainer from "components/common/img";
import { Col } from "reactstrap";
import { useNavigate } from "react-router";
import styled from "styled-components";

const DistrictCardContainer = styled.a`
  border-radius: 11px !important;
  border: none !important;
  width: 240px;
  height: 420px;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 310px;
  text-decoration: none;
  color: initial;
  margin-right: 0.5rem;
  margin-left: 0.5rem;

  img {
    width: 100%;
    height: 310px;
  }

  h6 {
    .text-bold {
      font-weight: bold;
    }
  }

  @media (max-width: 575.98px) {
    grid-template-rows: 200px !important;
    height: 330px !important;
    width: 170px !important;

    img {
      height: 200px !important;
    }
  }

  @media (max-width: 991.98px) {
    grid-template-rows: 260px;
    width: 210px;
    height: 400px;

    img {
      height: 260px;
    }
  }
`;

const RepresentativeDetailsContainer = styled.div`
  padding: 0.5rem;
`;

const RepresentativeName = styled.h6`
  font-weight: bold;
`;

const DistrictCard = (props) => {
  const navigate = useNavigate();

  const handleOnClick = (e) => {
    e.preventDefault();
    navigate(props?.link);
  };

  return (
    <DistrictCardContainer
      href="!#"
      onClick={(e) => handleOnClick(e)}
    >
      <ImgContainer src={props?.img} />

      <RepresentativeDetailsContainer>
        <Col>
          <RepresentativeName>
            {`${props?.lastName}, ${props?.firstName} ${
              props?.middleInitial !== null ? props?.middleInitial : ""
            }`}
          </RepresentativeName>
        </Col>
        <Col>
          <small>
            {props?.Party?.acronym !== "Partylist"
              ? props?.Party?.acronym
              : props?.District?.name?.split("-")[0]}
          </small>
        </Col>
      </RepresentativeDetailsContainer>
    </DistrictCardContainer>
  );
};

DistrictCard.propTypes = {
  img: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  middleInitial: PropTypes.string,
  Party: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ),
  District: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object])
  ),
};

export default DistrictCard;
